import * as React from "react";
import { TemplateSub } from "../../../components/layouts/TemplateSub";

export const TermsAndConditionsPage: React.FC = () => {
  return (
    <TemplateSub page="Terms & Conditions">
      <div className="px-4">
        {/* Scrollable content container */}
        <div className="flex flex-col mt-[1rem] h-[calc(100vh-180px)] bg-[#1E1E1E] rounded-xl overflow-hidden">
          {/* Scrollable content area */}
          <div className="overflow-y-auto p-6">
            <div className="text-white mb-6" style={{ fontWeight: "bolder" }}>
              Terms & Conditions - Njoy App (Users)
            </div>
            <div className="mb-6">
              <p className="text-white ">Effective Date: 26/08/2025 </p>
              <p className="text-white mb-6">Last Updated: 16/10/2025 </p>
            </div>

            <div className="text-white mb-6 ">
              <span className="text-white " style={{ fontWeight: "bolder" }}>
                Who we are:
              </span>{" "}
              <span className="opacity-80 text-white">
                The Njoy mobile-first progressive web application (“Njoy”,
                “App”) powered by Alami Platforms Limited (“we”, “us”, “our”) is
                a platform operated for users to access, discover and redeem
                curated perks and benefits from independent third-party
                merchants partners across food, entertainment, wellness,
                groceries, online courses and trainings, connectivity, and
                transportation.
              </span>
            </div>
            <div className="text-white mb-6">
              <span className="text-white " style={{ fontWeight: "bolder" }}>
                What these Terms do:
              </span>{" "}
              <span className="opacity-80 text-white">
                These Terms and Conditions (“Terms”) are a legal agreement
                between you and us. They explain how Njoy works, what you can
                expect from us, and what we expect from you. By creating an
                account or using the App which is accessible at{" "}
                <a
                  href="https://app.njoy.live"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-400 hover:underline"
                >
                  app.njoy.live
                </a>
                , you agree to be bound by these Terms and to our Privacy
                Policy. Please read these terms carefully before using the App;
                if you do not agree with these Terms, please do not use the App.
              </span>
            </div>
            <div className="text-white mb-6 ">
              <span className="text-white " style={{ fontWeight: "bolder" }}>
                Updates to these Terms:
              </span>{" "}
              <span className="opacity-80 text-white">
                We reserve the rights to modify these terms at anytime. When we
                do, we'll post the updated Terms in the App or notify you
                electronically. If you keep using Njoy after updates take
                effect, that means you accept the updated Terms. If you don't
                agree, you should stop using the App.
              </span>
            </div>

            <ol className="list-decimal pl-6 space-y-8">
              {/* Section 1 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Eligibility and Account Registration
                </h2>
                <div className="mb-3 text-white ">
                  <span className="text-white ">Who can use Njoy: </span>
                  <span className="opacity-80 text-white">
                    Njoy is intended for eligible individuals within Nigeria who
                    are at least 18 years old. To use Njoy, you must agree to
                    these Terms and our Privacy Policy. Some perks may only be
                    available to members of certain communities or in certain
                    locations.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">
                    You must provide accurate information:{" "}
                  </span>
                  <span className="opacity-80 text-white">
                    When you register, you agree to provide true, complete, and
                    up-to-date information (e.g., full name, date of birth,
                    email address, mobile number, location, bank credentials
                    where required, means of identification, and other details
                    we request from time to time). You are responsible for
                    ensuring your information is always up-to-date and agree not
                    to misrepresent your identity. If any of your details
                    change, update them in your Njoy account.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">Identity verification: </span>
                  <span className="opacity-80 text-white">
                    To keep the platform safe and ensure the right perks reach
                    the right people, we verify identity and eligibility. We (or
                    our verification partners) may request documents such as a
                    government-issued ID (passport, national ID card, or
                    driver's license), a selfie with your ID, BVN, and a recent
                    proof of address (e.g., utility bill or bank statement). We
                    may also ask for other documentation where necessary to
                    comply with the law. We reserve the right to suspend or
                    terminate your account if we find that any information you
                    provided is false, inaccurate, or misleading.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">
                    If information is false or misleading:{" "}
                  </span>{" "}
                  <span className="opacity-80 text-white">
                    If we reasonably believe the information, you provided is
                    false, misleading, or incomplete, or if you become
                    ineligible (for example, you are no longer part of a
                    required community), we may suspend or terminate your
                    account and/or restrict access to perks. This helps protect
                    our users, merchants, and partners.{" "}
                  </span>
                </div>
              </li>
              {/* Section 2 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Your Responsibilities
                </h2>
                <div className="mb-3 text-white">
                  <span className="text-white">Keep your account secure: </span>{" "}
                  <span className="opacity-80 text-white">
                    You are responsible for safeguarding your username,
                    password, and account information. Do not share your login
                    credentials or ID with anyone. You are solely responsible
                    for all activities and transactions that occur through your
                    account, whether you authorized them or not. If you think
                    someone has accessed your account without permission,
                    contact us immediately at{" "}
                    <a
                      href="mailto:contact@njoy.live"
                      rel="noopener noreferrer"
                      target="_blank"
                      className="text-indigo-400 hover:underline"
                    >
                      contact@njoy.live
                    </a>
                    . We are not liable for any losses that result from the
                    loss, theft, or compromise of your account.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">Use Njoy lawfully: </span>
                  <span className="opacity-80 text-white">
                    You must use the App and its services responsibly and
                    lawfully. You agree not to misuse the App by engaging in
                    fraudulent activities, reselling perks or offers, or
                    attempting unauthorized access to the App or other users'
                    accounts. Your use of the App is for your personal,
                    non-commercial benefit only, and you must not use it on
                    behalf of any third party. Using the App in a prohibited way
                    (e.g., fraud, reselling perks, bypassing eligibility
                    controls, unauthorized access) is not allowed. If you use or
                    attempt to use your account for unlawful purposes, we may
                    restrict your account, refuse to process transactions,
                    report to regulators or law enforcement, or take any other
                    lawful action. We are not liable or responsible if you use
                    the App in a way that violates applicable laws.{" "}
                  </span>
                </div>
              </li>
              {/* Section 3 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Perks, Benefits & Offers
                </h2>

                <div className="mb-3 text-white ">
                  <span className="text-white">What you're getting: </span>
                  <span className="opacity-80 text-white ">
                    Njoy curates access to discounts, promos, freebies, and
                    exclusive offers provided by independent third-party
                    merchants. We present these offers in the App; we do not
                    produce or sell the underlying goods or services. Offers are
                    shown based on your verified community and your location (so
                    two users may see different offers). Availability depends on
                    where you are or whether you meet a merchant's eligibility
                    criteria.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">Offers can change: </span>{" "}
                  <span className="opacity-80 text-white">
                    Merchant offers may be time-limited, have usage caps, or be
                    withdrawn without notice (for example, when a promo ends or
                    stock runs out). We do not guarantee that any specific perk
                    will be available at any time.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">Merchant responsibility: </span>{" "}
                  <span className="opacity-80 text-white">
                    Each merchant is solely responsible for their products,
                    services, pricing, fulfilment, and customer service. We do
                    not guarantee quality, safety, fitness for purpose, or
                    delivery timelines. Please review the specific terms on each
                    merchant's page before redeeming an offer, including any
                    expiry dates, usage limits, and refund/return policies.{" "}
                  </span>
                </div>
              </li>
              {/* Section 4 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Merchant Relationships and Third-Party Sites
                </h2>
                <div className="mb-3 text-white">
                  <span className="text-white">Independent partners: </span>{" "}
                  <span className="opacity-80 text-white">
                    Merchants on Njoy are independent partners, not employees,
                    agents, or representatives. We simply provide the platform
                    that connects you to them. Any dispute about a product or
                    service is between you and the merchant (though we encourage
                    you to contact us if you need help escalating).{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">Links to other sites: </span>
                  <span className="opacity-80 text-white">
                    The App may contain links to websites or services we don't
                    own or operate. These links are provided for your
                    convenience only. We don't endorse or control their content
                    and aren't responsible for their availability, features,
                    products, or practices. Your use of them is governed by
                    their terms and privacy policies. We encourage you to read
                    the terms and privacy policies of any third-party service
                    you visit or use.{" "}
                  </span>
                </div>
              </li>
              {/* Section 5 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Wallets, Payments & Fees
                </h2>
                <div className="mb-3 text-white">
                  <span className="text-white">Wallets: </span>
                  <span className="opacity-80 text-white">
                    Every user gets an Njoy Wallet and a virtual account number
                    through our licensed payment partners. You can fund your
                    wallet via bank transfer to your assigned virtual account
                    number and then pay merchants directly from your Njoy Wallet
                    to the merchant's wallet at checkout.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">
                    We don't process or hold payments:{" "}
                  </span>{" "}
                  <span className="opacity-80 text-white">
                    Njoy itself is not a bank or payment processor. We do not
                    hold or control your funds. Our payment partners operate the
                    payment infrastructure and provide the wallet accounts you
                    use within the App. (Your funds remain in your wallet until
                    you instruct that they be transferred to your bank account.)
                    You can check your wallet balance anytime by logging into
                    your account.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">
                    Transaction limits and sufficient funds:{" "}
                  </span>{" "}
                  <span className="opacity-80 text-white">
                    Transfers and payments may be subject to applicable
                    transaction and balance limits (for example, to comply with
                    regulations). If you don't have enough money in your wallet
                    to cover a transaction, it will be declined.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">Fees and transparency: </span>{" "}
                  <span className="opacity-80 text-white">
                    While there are generally no fees for using the Services,
                    transaction processing fees may apply and will be clearly
                    communicated to you within the App. We reserve the right to
                    introduce additional fees for our services in the future
                    upon notice; continuing to use the App after notice means
                    you agree to the applicable fees.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">Third-party charges: </span>
                  <span className="opacity-80 text-white">
                    You are responsible for any third-party fees that may arise
                    from your use of the Services (for example, your bank or
                    mobile network fees).{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">
                    Payment delays and system downtime:{" "}
                  </span>{" "}
                  <span className="opacity-80 text-white">
                    We strive for smooth payment experiences. However, delays
                    can occur due to issues with national payment rails (e.g.,
                    NIBSS) or payment partners. In such cases, we are not liable
                    for delays, disruptions, or processing errors caused by
                    factors beyond our control.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">
                    Refunds, reversals, and disputes:{" "}
                  </span>{" "}
                  <span className="opacity-80 text-white">
                    Payments you make to merchants are between you and that
                    merchant. Any refund, reversal, quality dispute, or
                    after-sales issue should be addressed with the merchant
                    under their policy. While we may try to help facilitate
                    communication, Njoy is not responsible for merchant refunds,
                    reversals, or disputes.{" "}
                  </span>
                </div>
              </li>
              {/* Section 6*/}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Refunds
                </h2>
                <div className="mb-3 text-white opacity-80">
                  At Njoy, we connect you with a variety of merchants who offer
                  perks and benefits on their products, services, and
                  experiences through our platform. Please note that purchases
                  made through Njoy are between you and the merchant. Njoy
                  itself does not sell or supply these products or services.
                </div>
                <div className="mb-3 text-white ">
                  Refunds Are Governed by Merchant Terms. Each merchant sets
                  their own refund, return, or cancellation policy. If you would
                  like to request a refund for a product or service, please
                  review the merchant's policy. It will determine whether you
                  are eligible for a refund and under what conditions. Njoy does
                  not determine refund entitlement and cannot override a
                  merchant's policy.
                </div>
                <div className="mb-3 text-white ">
                  Submitting a Refund Request. If you believe you're entitled to
                  a refund under a merchant's policy or applicable law, you can
                  submit a request by:
                </div>

                <ul className="list-disc pl-6 space-y-2 mb-4 text-white opacity-80">
                  <li>
                    Contacting the merchant directly through the contact details
                    provided on their store page or in your order confirmation,
                    or {" "}
                  </li>
                  <li>
                    Making a claim on the platform, reaching out to Njoy Support
                    on {" "}
                    <a
                      href="mailto:contact@njoy.live"
                      rel="noopener noreferrer"
                      target="_blank"
                      className="text-indigo-400 hover:underline"
                    >
                       contact@njoy.live, {" "}
                    </a>
                    who can help forward your request to the merchant for
                    review.{" "}
                  </li>
                </ul>
                <div className="mb-3 text-white opacity-80">
                  We'll share your refund request and any supporting details
                  with the merchant promptly.
                </div>
                <div className="mb-3 text-white ">
                  Review and Resolution Process. Once the merchant receives your
                  request:
                </div>
                <ul className="list-disc pl-6 space-y-2 mb-4 text-white opacity-80">
                  <li>
                    The merchant will respond within a reasonable period, either
                    confirming or disputing the refund.{" "}
                  </li>
                  <li>
                    If the merchant disputes the refund, they may provide
                    additional information or evidence.
                  </li>
                  <li>
                    If the merchant confirms the refund or it is determined that
                    you are entitled to one under their policy, the refund will
                    processed promptly.{" "}
                  </li>
                </ul>

                <div className="mb-3 text-white ">
                  Timing of Refunds. After confirmation, refunds are typically
                  processed within 5 - 10 business days, depending on your
                  payment method and financial institution.
                </div>

                <div className="mb-3 text-white ">
                  Njoy's Role and Limitation of Liability. Njoy acts solely as a
                  facilitator of payments and communication between Users and
                  merchants. We:
                </div>

                <ul className="list-disc pl-6 space-y-2 mb-4 text-white opacity-80">
                  <li>Do not determine refund eligibility. </li>
                  <li>
                    Are not responsible for the quality, delivery, or
                    performance of merchant products or services.{" "}
                  </li>
                  <li>
                    Are not liable for any losses or damages arising from refund
                    disputes between you and a merchant.{" "}
                  </li>
                  <li>
                    Any refund granted will be processed strictly in line with
                    the merchant's policy and applicable laws.{" "}
                  </li>
                </ul>
                <div className="mb-3 text-white ">
                  Contact Us. If you have questions about this Refund Policy or
                  need help contacting a merchant, please reach out to us at {" "}
                  <a
                    href="mailto:contact@njoy.live"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-indigo-400 hover:underline"
                  >
                    contact@njoy.live
                  </a>
                </div>
              </li>

              {/* Section 6 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Privacy & Data Use
                </h2>
                <div className="mb-3 text-white opacity-80">
                  <span className="text-white">
                    Your privacy matters to us.{" "}
                  </span>{" "}
                  Your use of Njoy is subject to our Privacy Policy, which
                  explains what personal data we collect, why and how we collect
                  it, how we share it, and your choices and rights under
                  applicable Nigerian data protection laws. Please read the
                  Privacy Policy carefully before using the App.{" "}
                </div>
              </li>
              {/* Section 7 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Intellectual Property
                </h2>
                <div className="mb-3 text-white opacity-80">
                  All rights in the App, including software, features, design,
                  text, graphics, logos, and trademarks (except merchant
                  trademarks), exclusively belongs to us. You may use the App
                  only as permitted in these Terms. You may not copy, modify,
                  reverse engineer, distribute, or create derivative works from
                  any part of the App without our prior written permission.
                </div>
              </li>
              {/* Section 8 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Suspension, Termination & Closing Your Account
                </h2>
                <div className="mb-3 text-white ">
                  <span className="text-white">Our rights: </span>
                  <span className="opacity-80 text-white">
                    We may suspend or terminate your account (with or without
                    notice, depending on urgency and the law) if we reasonably
                    believe you violated these Terms, engaged in fraud or
                    misuse, or provided false information, or if required by
                    law/enforcement.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">Your choice: </span>
                  <span className="opacity-80 text-white">
                    You may close or deactivate your account at any time from
                    your profile or by contacting support.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">What happens next: </span>
                  <span className="opacity-80 text-white">
                    After termination or deactivation, you will lose access to
                    the App and to any Njoy-based perks or benefits that require
                    an active account. Outstanding obligations (for example,
                    amounts owed to merchants) continue to apply and any balance
                    in your wallet shall be transferred to your designated bank
                    account.{" "}
                  </span>
                </div>
              </li>
              {/* Section 9 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Disclaimers and Limitation of Liability
                </h2>
                <div className="mb-3 text-white">
                  <span className="text-white">
                    Service and offers provided “as is.”:{" "}
                  </span>{" "}
                  <span className="opacity-80 text-white">
                    The App and the perks displayed are provided on an “as is”
                    and “as available” basis. We do not promise that every perk
                    will always be available, that the App will be uninterrupted
                    or error-free, or that merchants' products/services will
                    meet your expectations.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">
                    Merchant and connectivity disclaimers:{" "}
                  </span>{" "}
                  <span className="opacity-80 text-white">
                    We are not responsible for merchant quality issues, delivery
                    failures, or any financial losses you may incur from using
                    an offer. We are also not responsible for connectivity
                    issues (e.g., device, network, or internet problems).{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">Limitation of liability: </span>{" "}
                  <span className="opacity-80">
                    TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, YOU AGREE
                    THAT ALAMI PLATFORMS LIMITED, ITS AFFILIATES AND THEIR
                    RESPECTIVE EMPLOYEES, OFFICERS, DIRECTORS, AGENTS, PARTNERS,
                    REPRESENTATIVES AND THIRD-PARTY SERVICE PROVIDERS WILL NOT
                    BE LIABLE TO YOU OR ANY THIRD PARTY FOR (A) THE PERFORMANCE
                    OF THE SERVICES OR THE INABILITY TO USE THE SERVICES; (B)
                    ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE,
                    OR EXEMPLARY DAMAGES, WHETHER BASED IN CONTRACT, TORT, OR
                    OTHERWISE, INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS
                    OF PROFITS, GOODWILL, USE, DATA, OR OTHER INTANGIBLE LOSSES,
                    EVEN IF SUCH PERSONS HAVE BEEN ADVISED OF THE POSSIBILITY OF
                    SUCH DAMAGES, WHICH ARISE OUT OF OR ARE IN ANY WAY CONNECTED
                    WITH THESE TERMS OR SERVICES (D) ANY EVENT BEYOND OUR
                    REASONABLE CONTROL. TO THE FULLEST EXTENT PERMITTED BY
                    APPLICABLE LAW, WE WILL NOT BE LIABLE FOR THE ACTIONS OR
                    INACTIONS OF ANY THIRD PARTY NOT ACTING ON OUR INSTRUCTIONS,
                    AND WE WILL NOT BE LIABLE FOR ACTIONS OR INACTIONS NOT
                    DIRECTLY TRACEABLE TO US. .{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">
                    Payment-rail downtime disclaimer:{" "}
                  </span>{" "}
                  <span className="opacity-80">
                    WE STRIVE TO ENSURE SEAMLESS PAYMENT PROCESSING THROUGH OUR
                    PAYMENT PARTNERS. HOWEVER, DUE TO FACTORS BEYOND OUR
                    CONTROL, INCLUDING BUT NOT LIMITED TO DOWNTIMES OR
                    DISRUPTIONS IN THE NIGERIA INTER-BANK SETTLEMENT SYSTEM
                    (NIBSS) OR OUR PAYMENT PARTNERS, PAYMENTS MAY BE DELAYED.
                    THUS, WE SHALL NOT BE LIABLE FOR ANY PAYMENT DELAYS,
                    DISRUPTIONS, OR ERRORS IN THE PROCESSING OF PAYMENTS
                    RESULTING FROM SUCH DOWNTIMES, TECHNICAL DISRUPTIONS, OR
                    OTHER FACTORS BEYOND OUR CONTROL.{" "}
                  </span>
                </div>
              </li>
              {/* Section 10 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Indemnity
                </h2>
                <div className="mb-3 text-white opacity-80">
                  You agree to indemnify and hold harmless Njoy (Alami Platforms
                  Limited), its affiliates, directors, employees, agents, and
                  partners from and against any claims, losses, liabilities,
                  damages, costs, or expenses (including reasonable legal fees)
                  arising out of or related to: (a) your misuse of the App; (b)
                  your breach of these Terms; (c) any content or information you
                  submit; or (d) any dispute or transaction between you and a
                  merchant.
                </div>
              </li>
              {/* Section 11 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Dispute Resolution & Governing Law
                </h2>
                <div className="mb-3 text-white ">
                  <span className="text-white">Talk to us first: </span>
                  <span className="opacity-80 text-white">
                    If you have a complaint or dispute, please contact our
                    Customer Support. We'll try to resolve issues quickly and
                    fairly within fourteen (14) business days.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">Arbitration: </span>
                  <span className="opacity-80 text-white">
                    If a dispute is not resolved within that time, it will be
                    settled by binding and confidential arbitration under the
                    Arbitration and Mediation Act 2023 in Nigeria (not state
                    arbitration law). There will be one arbitrator, appointed
                    jointly by both parties within fourteen (14) Business Days
                    of referral; failing agreement, the sole arbitrator will be
                    appointed by the Chairman of Chartered Institute of
                    Arbitrators, United Kingdom, Nigeria Branch at the request
                    of either party. The seat/venue of arbitration is Abuja,
                    Nigeria, proceedings will be in English, and the
                    arbitrator's decision is final and binding. The arbitrator
                    will honour legal privileges and privacy; the arbitration is
                    confidential; subject to these Terms' liability limits, the
                    arbitrator may award any individual relief permitted by law;
                    each party bears its own legal fees. An arbitral award may
                    be entered in any court of competent jurisdiction. Either
                    party may seek interim or injunctive relief in court to
                    protect its rights before arbitration. This section survives
                    termination of these Terms. If any part of it is invalid or
                    unenforceable, the remainder stays in effect.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">Governing law: </span>
                  <span className="opacity-80 text-white">
                    These Terms are governed by the laws of the Federal Republic
                    of Nigeria.{" "}
                  </span>
                </div>
              </li>
              {/* Section 12 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Changes to the Service
                </h2>
                <div className="mb-3 text-white opacity-80">
                  We may change, suspend, or discontinue any part of the App
                  (including features or availability of offers) at any time. We
                  will notify you of material changes in the App or by email.
                  Your continued use of the App after changes take effect means
                  you accept the changes.
                </div>
              </li>
              {/* Section 13 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  General Terms
                </h2>
                <div className="mb-3 text-white ">
                  <span className="text-white">Entire agreement: </span>
                  <span className="opacity-80 text-white">
                    These Terms, together with the Privacy Policy form the
                    entire agreement between you and us regarding the App and
                    supersede any prior understandings.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">Non-waiver: </span>
                  <span className="opacity-80 text-white">
                    If we don't enforce a right under these Terms, that doesn't
                    mean we waive it. We may enforce our rights later.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white">
                  <span className="text-white">Severability: </span>
                  <span className="opacity-80 text-white">
                    If any part of these Terms is found invalid or
                    unenforceable, the rest of the Terms will continue in full
                    force.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">
                    Electronic Signature and Consent:{" "}
                  </span>{" "}
                  <span className="opacity-80 text-white">
                    By clicking “I Agree,” “I Accept,” or otherwise using the
                    Njoy App, you acknowledge and agree that such action
                    constitutes your electronic signature to these Terms and the
                    Privacy Policy. You further agree that your electronic
                    signature is the legal equivalent of your handwritten
                    signature and has the same force and effect under applicable
                    law.{" "}
                  </span>
                </div>
                <div className="mb-3 text-white ">
                  <span className="text-white">Force Majeure: </span>
                  <span className="opacity-80 text-white">
                    We aren't responsible for delays or failures caused by
                    events beyond our reasonable control (for example: natural
                    disasters, strikes, acts of government, war, civil
                    disturbances, power or internet failures, or payment-system
                    outages).{" "}
                  </span>
                </div>
              </li>
              {/* Section 14 */}
              <li className="pl-2 text-white">
                <h2 className="text-xl font-semibold mb-3 text-white">
                  Contact Us
                </h2>
                <div className="text-white opacity-80">
                  Questions, complaints, or feedback? We're here to help. Kindly
                  contact our support at{" "}
                  <a
                    href="mailto:contact@njoy.live"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-indigo-400 hover:underline"
                  >
                    contact@njoy.live
                  </a>
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </TemplateSub>
  );
};
